import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    Divider
} from '@mui/material';
import Rating from '@mui/material/Rating';

const ChatRatingModal = ({ open, onClose, chat }) => {
    if (!chat) return null;
    const { agent_name, agent_id, chat_rating, chat_rating_comments } = chat;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Chat Rating</DialogTitle>
            <DialogContent dividers>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                    Agent: {agent_name || agent_id}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Rating value={chat_rating || 0} readOnly max={5} precision={1} size="medium" />
                    <Typography variant="body2" sx={{ ml: 1 }}>
                        {chat_rating ? `(${chat_rating})` : 'N/A'}
                    </Typography>
                </Box>
                <Divider sx={{ mb: 2 }} />
                <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
                    {chat_rating_comments || 'No comment left.'}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained">Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ChatRatingModal;
